import * as queryString from 'query-string';

const parseQueryParams = ({ search }: any) => queryString.parse(search);

export default parseQueryParams;
